import { useApi } from "../../../swr/useApi";
import { productResolutionsService } from "../../api_client";
import type { ProductResolutionDto } from "../../../api";

export function useProductResolutions() {
    return useApi<ProductResolutionDto[]>("product-resolutions", async () => {
        return await productResolutionsService.getProductResolutions();
    });
}

